import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/utils/contexts/AreaContext.tsx");
